/* eslint-disable no-template-curly-in-string */
import React, { Fragment } from 'react';
// import Table from '../../components/global/Table';
import CelaneseAPI from '../../services';
import config, { utils } from '../../config';
import swal from 'sweetalert';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Table, Input, Button  } from 'antd';
import './TowsItemsImportExport.css';
import tableHeader from '../../model/TowItemSelectionTableHeader';
import { towItemsData } from '../../actions/index';
import Translation from '../../Translation';

/**
 * Class for tow items import and export.
 *
 * @class TowItemsImportExport
 * @extends {React.Component}
 */
class TowItemsImportExport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: [],
            tableHeaders: [],
            filters: {},
            defaultSelectedItems: [],
            bordered: true,
            loading: true,
            size: 'small',
            title: undefined,
            showHeader: true,
            pagination: false,
            scroll: { x: '150vh' | false },
            hasData: true,
            searchText: [],
            showingCount: 0
        };
        this.importFile = this.importFile.bind(this);
        this.getTowItems = this.getTowItems.bind(this);
        this.exportFile = this.exportFile.bind(this);
        this.displayTowitems = this.displayTowitems.bind(this);
    }
    /**
     * filterDropdown function is for showing dropdown for each column in the tow items table.
     *
     * @param {Object} opts which is object, it will take selected row keys and user confirmation.
     * @memberof TowItemsImportExport
     */
    filterDropdown = (opts) => {
        let that = this;
        return (
        <div className="custom-filter-dropdown">
            <Input
                ref={ele => that.searchInput = ele}
                placeholder={utils.getTranslationText('lbl_filter_text', 'Filter text or =,<,>,=>,<=')}
                value={opts.selectedKeys[0]}
                onChange={e => opts.setSelectedKeys(e.target.value ? [e.target.value] : [])}
                onPressEnter={that.handleSearch(opts.selectedKeys, opts.confirm)}
            />
            <Button type="primary" onClick={that.handleSearch(opts.selectedKeys, opts.confirm)}><Translation labelName="lbl_search" defaultText="Search" /></Button>
            <Button onClick={that.handleReset(opts.clearFilters)}><Translation labelName="lbl_reset" defaultText="Reset" /></Button>
        </div>)
    }
    /**
     * onFilterDropdownVisibleChange function is for toggling the search input visibility.
     * 
     * @param {boolean} visible takes boolean as input
     * @memberof TowItemsImportExport
     */
    onFilterDropdownVisibleChange = (visible) => {
        let that = this;
        if (visible) {
            setTimeout(() => {
                that.searchInput.focus();
            });
        }
    }
    /**
     * tableRender function is for rendering of highlighted text.
     * 
     * @param {string} text which will take string as input
     * @memberof TowItemsImportExport
     */
    tableRender = (text) => {
        const { searchText } = this.state;
        return searchText ? (
          <span>
            {text.split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')).map((fragment, i) => (
              fragment.toLowerCase() === searchText.toLowerCase()
                ? <span key={i} className="highlight">{fragment}</span> : fragment // eslint-disable-line
            ))}
          </span>
        ) : text;
    }
    /**
     * handleSearch function is for performing search on the table with selected row keys.
     *
     * @param {array} selectedKeys
     * @param {func} handleConfirm
     * @memberof TowItemsImportExport
     */
    handleSearch = (selectedKeys, handleConfirm) => () => {
        handleConfirm();
        this.setState({ searchText: selectedKeys[0] });
    }

    /**
     * handleReset function is for clearing searched fields on the table.
     *
     * @param {func} clearFilters
     * @memberof TowItemsImportExport
     */
    handleReset = clearFilters => () => {
        clearFilters();
        this.setState({ searchText: '' });
    }
    /**
     * getTowItems function is for getting the towitems data from redux/store.
     *
     * @param {object|array} propsData
     * @memberof TowItemsImportExport
     */
    getTowItems(propsData) {
        let items = this.props.itemData.length ? this.props.itemData : propsData;
        if(items && items.length) {
            this.displayTowitems(items);
        }
    }

    /**
     * displayTowitems function is for displaying all the items which we get from the redux/store.
     *
     * @param {object|array} items
     * @memberof TowItemsImportExport
     */
    displayTowitems(items) {
        let headers = Object.keys(items[0]).filter(item => {
            switch (item) {
                case 'id':
                case 'createdAt':
                case 'updatedAt':
                case 'minwt2':
                case 'mixpddry':
                case 'tgtwtdry':
                case 'tgtpddry':
                case 'maxwtdry':
                case 'maxpddry':
                case 'tgtpd':
                    break;
                default:
                    return item;
            }

            return false;
        });

        let newData = items.map((obj) => {
            var Obj = {};
            headers.map(header => {
                if (header === 'plantcode') {
                    let plants = {
                        "C": "Celco",
                        "O": "Ocotlan",
                        "L": "Lanaken",
                        "S": "Spondon"
                    };
                    Obj[header] = plants[obj[header]] || obj[header];
                }               
                else {
                    Obj[header] = obj[header];
                }
                return Obj;
            });
            return Obj;
        });

        this.setState({
            rows: newData,
            tableHeaders: headers,
            loading: false
        });
    }
    UNSAFE_componentWillMount() {
        this.getTowItems();
    }
    componentWillReceiveProps(newProps) {
        let items = newProps.itemData;
        if (items) {
            this.getTowItems(items);
        }
    }
    /**
     * continueImporting function is for continuing the procedure after initial validation of the importing excel data.
     *
     * @param {object} formData
     * @memberof TowItemsImportExport
     */
    continueImporting(formData) {
        swal({
            text: utils.getTranslationText('msg_importing_tow_item_sheet','Importing Tow Items Sheet...'),
            buttons: false, 
            className: 'import-btn-swal'
        });
        CelaneseAPI.post('/towitems/import', formData, { isUpload: true }).then(resp => {
            if (resp.data && !resp.error) {
                //Importing Done
                CelaneseAPI.get(config.API.towItems).then(resp => {
                    let items = resp.data || [];
                    if (items.length) {
                        swal({
                            title: utils.getTranslationText('msg_import_success','Import Successful'),
                            text: utils.getTranslationText('msg_Importing_towitems_sheet_done_successfully','Importing Towitems sheet is done successfully'),
                            buttons: [utils.getTranslationText('btn_ok','OK')],
                            timer: 3000
                        });
                        setTimeout(()=> {
                            this.displayTowitems(items);
                        }, 1000);
                        this.props.towItemsData(items);
                    } else {
                        swal.close();
                    }
                });
            } else {
                swal({
                    text: resp.error,
                    buttons: [utils.getTranslationText('btn_ok','OK')]
                });
            }
        });
    }
    /**
     * importFile function is for importing the towitems. At first we validate the sheet, 
     * if it succeeds then we proceed with importing the excel
     *
     * @param {*} e here e is an event passed as input
     * @returns
     * @memberof TowItemsImportExport
     */
    importFile(e) {
        e.preventDefault();
        let inputElem = document.querySelector('input[type="file"]');
        let extenstion = inputElem.value.split('.xls')[1];
        if (!inputElem.value)
            return;
        if ((extenstion === 'x' || extenstion === '')) {
            //do
            swal({
                text: utils.getTranslationText('msg_validating_sheet','Validating Sheet...'),
                buttons: false,
                className: 'import-btn-swal'
            });
            const files = inputElem.files;
            const formData = new FormData();
            for (let i = 0; i < files.length; i++) {
                let file = files[i];
                formData.append('file', file);
            }
            inputElem.value = '';
                    
            CelaneseAPI.post('/towitems/validateexcel', formData, { isUpload: true }).then(resp => {
                if (!resp.data && resp.error) {
                    if (resp.validation && (resp.validation.emptySheet || resp.validation.itemLotRepeat || resp.validation.emptyItemlot || resp.validation.isHavingDataTypeError)) {
                        let msg = utils.getTranslationText('msg_tow_item_sheet_empty_values','The tow item sheet contains empty values.');
                        if (resp.validation.isHavingDataTypeError) {
                            let dataTypeDetails = resp.validation.dataTypeDetails;
                            msg = utils.getTranslationText('msg_sheet_values_has_format_values', "Sheet has wrong format values. '${columnName}' field has '${columnValue}' as value expecting '${expectedType}' type values at possible '${itemRow}' row item")
                                    .replace('${columnName}', dataTypeDetails.columnName)
                                    .replace('${columnValue}', dataTypeDetails.colValue)
                                    .replace('${expectedType}', dataTypeDetails.expectedType)
                                    .replace('${itemRow}', dataTypeDetails.itemRow)
                        }

                        if (resp.validation.emptyItemlot) {
                            let emptyFieldDetails = resp.validation.emptyFieldDetails;
                            msg = utils.getTranslationText('msg_sheet_has_empty_value', "Sheet has '${columnName}' field has empty value at '${possibleRowNumber}' row item").replace('${columnName}', emptyFieldDetails.columnName).replace('${possibleRowNumber}', emptyFieldDetails.possibleRowNumber);
                        }
                        if (resp.validation.itemLotRepeat) {
                            let duplicationDetails = resp.validation.duplicationDetails;
                            msg = utils.getTranslationText('msg_sheet_has_duplicate_values', "Sheet has itemlot field with duplicate values at '${duplicationRows}' item rows.").replace('${duplicationRows}', duplicationDetails.duplicationRows);
                        }

                        if (resp.validation.emptySheet) {
                            msg = utils.getTranslationText('msg_sheet_zero_items','Sheet has zero items');
                        }
                        swal({
                            text: msg,
                            button: utils.getTranslationText('btn_ok','OK'),
                            className: 'warning-btn-swal',
                        });
                    } else {
                        swal({
                            text: resp.error,
                            button: utils.getTranslationText('btn_ok','OK')
                        });
                    }
                } else {
                    this.continueImporting(formData);
                }
            });
        } else {
            swal({
                text: utils.getTranslationText('msg_excel_files_only', 'Excel files only'),
                buttons: [utils.getTranslationText('btn_ok','OK')]
            });
        }
    }

    /**
     * downloadFile function is for downloading of towitems, in other words it's an exporting feature
     *
     * @memberof TowItemsImportExport
     */
    downloadFile() {
        swal({
            title: utils.getTranslationText('msg_fetching_tow_items','Fetching tow items'),
            text: utils.getTranslationText('msg_download_start_in_few_seconds','Download will start in few seconds...'),
            buttons: false
        });
        /**
         * API call for exporting towitems in excel format
         */
        CelaneseAPI.getBlob('/towitems/export?format=excel').then(resp => {
            if (resp.error) {
                swal({
                    text: resp.error
                });
                return;
            }
            let element = document.getElementById('export-towitems-link');
            if(document.body.classList.contains('ie11')) {
                window.navigator.msSaveOrOpenBlob(resp, 'tow-items-' + new Date().getTime() + '.xlsx');
                swal.close();
            } else {
                element.setAttribute('href', window.URL.createObjectURL(resp));
                element.setAttribute('download', 'tow-items-' + new Date().getTime() + '.xlsx');
                setTimeout(() => {
                    element.click();
                    swal.close();
                }, 1000);
            }
        });
    }
    /**
     * exportFile function is for initial check for the user to proceed further or not in case when there are no tow items.
     *
     * @param {*} e here e is event passed as event
     * @memberof TowItemsImportExport
     */

    exportFile(e) {
        e.preventDefault();
        if (this.state.rows.length === 0) {
            swal({
                text: utils.getTranslationText('msg_database','Database has zero tow items, Do you want to continue to export with empty tow items?'),
                buttons: [utils.getTranslationText('lbl_no', 'No'), utils.getTranslationText('lbl_yes', 'Yes')]
            }).then((action) => {
                if (action) {
                    this.downloadFile();
                }
            });
        } else {
            this.downloadFile();
        }

    }

    /**
     * chooseFile function is for initial check for the user that it will override the existing DB, on
     * user confirmation the file will be imported.
     *
     * @param {*} e
     * @memberof TowItemsImportExport
     */
    chooseFile(e) {
        e.preventDefault();
        swal({title: utils.getTranslationText('msg_are_u_sure', 'Are you sure?'),
            text: utils.getTranslationText('msg_existing_db', 'This will override the existing DB.'),
            icon: 'warning',
            buttons: [ utils.getTranslationText('btn_cancel', 'Cancel'), utils.getTranslationText('btn_continue', 'Continue')],
            dangerMode: true,
        }).then((confirm)=> {
            if(confirm) {
                document.querySelector('#file-import').click();
            }
        });
    }

    render() {

        const setCustomFilters = (header) => {
            header.filterDropdown = this.filterDropdown;
            header.onFilterDropdownVisibleChange = this.onFilterDropdownVisibleChange;
            header.tableRender = this.tableRender;
        }

        tableHeader.map(header => {
            if (!header.nocustomfilter)  {
                if (header.children) {
                    header.children.map(child => setCustomFilters(child));
                } else {
                    setCustomFilters(header)
                }
            }
            return true;
        });


        return (
            <Fragment>
                <div className="managetow-heading">
                    <h2><Translation labelName="title_admin_manage_tow_items" defaultText="Manage Tow Items" /></h2>
                    <div className="btn-wrapper">
                    {
                        this.state.rows.length ? (
                            <h4 className="tow-length-label"><Translation labelName="lbl_available_tow_items" defaultText="Available tow items" />: <strong>{this.state.rows.length}</strong></h4>
                        ) : ''
                    }
                        <button type="button" className="btn btn-default import-file-btn" onClick={(e) => this.chooseFile(e)}><Translation labelName="btn_import" defaultText="Import" /></button>
                        <button type="button" className="btn btn-default export-file-btn" onClick={(e) => this.exportFile(e)}><Translation labelName="btn_export" defaultText="Export" /></button>
                        <input id="file-import" onChange={(e) => this.importFile(e)} type='file' accept='.xls,.xlsx' />
                        {/* <a href='/help/html/Tow_Item_Database.htm' target="_blank" title="Help" className="help-section m2-left">
                            <img
                                src="./images/help-inverse-black.svg"
                                alt="help"
                                className="help-icon" />
                        </a> */}
                    </div>
                </div>
                <div className="container-fluid managetow-container">
                    <div className="table-wrapper">
                        <Table {...this.state} 
                            rowKey="itemlot"
                            columns={tableHeader}
                            dataSource={this.state.rows ? this.state.rows : null} 
                            scroll={{ y: 'calc(100vh - 292px)' }}
                        />
                    </div>
                </div>
                <a href="" className="export-towitems-hidden" id="export-towitems-link" download=""></a>
            </Fragment>
        );
    }
}


const mapStateToProps = ({ towItemsState }) => ({
    itemData: towItemsState.itemData
});

const mapDispatchToProps = dispatch => ({
    towItemsData: (data) => dispatch(towItemsData(data))
});

export default connect(mapStateToProps,mapDispatchToProps)(TowItemsImportExport);

TowItemsImportExport.propTypes = {
    towItemsData: PropTypes.func,
    itemData: PropTypes.array
}


// WEBPACK FOOTER //
// ./src/containers/TowItemsImportExport/index.js